<template>
  <div class="w-full">

    <div class="w-full prose text-center mx-auto mt-24">
      <h2>
        Thank you!
      </h2>
      <p>You're on the waitlist! We'll be in touch when we launch.</p>
    </div>


  </div>
</template>


<script setup>


</script>